export default {
    previousPage:'Предыдущая страница',
    confirm:'подтверждение',
    sensorCheck:'проверка датчиков',
    batteryType:'тип батареи',
    smartBattery:'интеллектуальный элемент',
    nonIntelligentBattery:'неинтеллигентный элемент',
    battery:'батарея',
    power:'количество электричества',
    voltage:'напряжение',
    temperature:'температура',
    parachute:'парашют',
    parachuteStatus:'режим самоконтроля парашюта',
    selfTestFailed:'самопроверка не прошла',
    selfCheckPassed:'пройти самоконтроль',
    parachutingState:'режим раскрытия парашюта',
    locked:'Заблокировано',
    unlocked:'Разблокировано',
    umbrellaOpened:'открытый парашют',
    compass:'компас',
    range:'Сфера применения',
    accelerometer:'акселерометр',
    satellite:'спутник',
    positioningAccuracy:'точность позиционирования',
    positioningType:'тип позиционирования',
    positioning:'локализация',
    noPositioning:'отсутствие ориентировки',
    poorPositioning:'ошибка позиционирования',
    singlePointPositioning:'одноточечное решение',
    differentialPositioning:'дифференциальное позиционирование',
    floatingPointRelocation:'определение места с плавающей запятой',
    fixedUnposition:'фиксированное решение',
    radar:'радиолокатор',
    front:'вперёд',
    after:'задний',
    lower:'низший',
    left:'левый',
    right:'справа',
    structuralInspection:'проверка конструкции',
    input:'вход',
    structuralInspection1:'проверка соответствия фактического направления носовой части компасу',
    structuralInspection2:'Проверить правильность установки каждого винта',
    structuralInspection3:'Проверить правильность поворота и установки двигателя',
    structuralInspection4:'проверка прочности установки батареи',
    structuralInspection5:'проверка герметизации фюзеляжа и плеча машины',
    structuralInspection6:'проверка установки антенн',
    structuralInspection7:'проверка прочности установки шасси',
    structuralInspection8:'проверка установки парашюта',
    communicationCheck:'Проверка связи',
    dataLink:'цепочка данных',
    dataLink1:'состояние соединения беспилотника с сервером с использованием модуля связи T15',
    dataLink2:'состояние соединения беспилотника с сервером',
    notConnected:'не подключаться',
    connected:'Подключено',
    notObtained:'не получить',
    mobileNetwork:'подвижная сеть',
    mobileNetwork1:'В некоторых районах синьцзяна, Тибета, юньнана и гуанси из - за региональных ограничений на доступ к Интернету может возникнуть ситуация, когда летательные аппараты не могут выйти в интернет, и эта проблема может быть решена путем замены местных SIM - карт.',
    mobileNetwork2:'для сценариев, требующих более высоких требований к сети, рекомендуется использовать неавтоматизированную сетевую карту.',
    mobileNetwork3:'диапазон RSI: - 50 - 70, ниже этого значения, означает, что сигнал сети является слабым.',
    surplus:'остаток',
    remoteControl:'дистанционный пульт',
    externalHandle:'выносная рукоятка',
    configurationCheck:'Проверка конфигурации',
    flightMode:'режим полёта',
    flightMode1:'полёт',
    flightMode2:'Режим взлёта',
    flightMode3:'режим посадки',
    flightMode4:'обратный режим',
    flightMode5:'возвратный режим',
    flightMode6:'обратный режим',
    flightMode7:'точечный режим',
    flightMode8:'режим обхода',
    flightMode9:'пространственная модель',
    flightMode10:'режим установки высоты',
    flightMode11:'точечный режим',
    flightMode12:'автоматическая авиалиния',
    flightMode13:'модель точки AB',
    remoteControlHandType:'ручной тип пульта управления',
    americanHand:'американец',
    japaneseHand:'японец',
    chineseHands:'китайские руки',
    remoteControlHight:'ограничение высоты пульта управления',
    rcProtect:'защита от неуправляемости пульта управления',
    noAction:'бездействие',
    hover:'висение',
    straightReturn:'прямолинейная обратная навигация',
    directReturn:'прямой обратный рейс',
    linkRunawayProtection:'защита канала',
    RTKtakeoff:'разрешить взлет без RTK',
    notAllow:'нельзя',
    allow:'позволять',
    returnAltitude:'высота возврата',
    returnSpeed:'скорость возврата',
    returnDirection:'направление возврата',
    headOrientation:'носовое направление',
    tailOrientation:'хвостовое направление',
    lowPowerProtection:'низковольтная защита',
    level1Alarm:'первый сигнал тревоги',
    level2Alarm:'двухступенчатая сигнализация',
    acoustoOpticAlerting:'световая тревога',
    beelineReturn:'прямолинейная обратная навигация',
    originalReturn:'обратный рейс',
    land:'посадка',
    parachuteDetection:'проверка парашюта',
    close:'закрыть',
    open:'открыть',
    loadCheck:'проверка нагрузки',
    FPVimage:'изображение FPV',
    PTZpod:'подвесная гондола',
    pager:'крик',
    loudspeakerInspection:'реверберация',
    thrower:'сбрасыватель',
    pitchControl:'Управление по тангажу',
    courseControl:'управление курсом',
    zoomControl:'управление масштабированием',
    photoControl:'фотоуправление',
    startRecording:'начать запись',
    endRecording:'закончить запись',
    imageSwitching:'переключение изображения',
    targetSolution:'решение задачи',
    zuo:'левый',
    you:'справа',
    whole:'все',
    danguang:'видимый свет',
    shuangguang:'видимый свет + инфракрасный свет',
    sanguang:'видимый свет + инфракрасный + лазер (три света)',
    notInstalled:'монтаж',
    alreadyInstalled:'уже установлено',
    pleaseSelect:'Выберите',
    airspaceInspection:'проверка воздушного пространства',
    airspaceInspection1:'готовность к полетам',
    airspaceInspection2:'Утверждение заявки на воздушное пространство',
    airspaceInspection3:'пролетают ли беспилотные летательные аппараты через запретную для полетов зону',
    airspaceInspection4:'пролетают ли беспилотные летательные аппараты через запретную для полётов зону',
    airspaceInspection5:'пересекают ли беспилотные летательные аппараты место взлета или маршрут через густонаселенную зону',
    tip1:'запретная для полетов зона: летательные аппараты ни при каких обстоятельствах не могут взлетать или вторгаться в эту зону.',
    tip2:'запретная для полетов зона представляет собой закрытую зону координат с неограниченной высотой в 12 координатных точках, установленных Управлением гражданской авиации (УГА) в качестве пограничной точки на границах заграждений в гражданских аэропортах и буферной зоне допуска.',
    tip3:'зона, ограниченная полетом: воздушное судно может взлетать или заходить в зону, ограниченную высотой полета.',
    tip4:'зона, ограниченная полетом, представляет собой радиус 25 км с центром и радиусом 25 км, расположенным на передней оси взлетно - посадочной полосы, которая ограничивается высотой 50 метров и не пересекается с ней.',
    tip5:'под густонаселенными районами понимаются города, деревни, оживленные дороги или крупные открытые места.',
    tip6:'количество и концентрация людей в этом районе требуют осторожного подхода.',
    yes:'Да',
    no:'Нет',
    inspectionOverview:'контрольный обзор',
    signOut:'выход',
    save:'Сохранить',
    savingSucceeded:'сохранить успешно',
    time:'период',
    times:'время',
    inspectors:'инспектор',
    phone:'мобильный телефон',
    inspectionTime:'время проверки',
    details:'подробности',
    chinaTelecom:'China Telecommunication',
    chinaMobile:'перемещение в китай',
    chinaUnicom:'China Union',
    parachuteStatu:'Положение парашюта',
    camera:'веб - камера',
    exportPicture:'Экспорт изображений',
    inspectionRecord:'Проверка записей',
    tip_PCTR: 'Please check the remote control configuration',
}